<template>
  <div>
    <v-row>
      <span v-show="false">{{title}}</span>
      <v-col cols="12" md="4">
        <cash-and-bank></cash-and-bank>
      </v-col>
      <v-col cols="12" md="8">
        <cheque-table></cheque-table>
      </v-col>
      <v-col cols="12" md="6">
        <highest-balance-amount-table></highest-balance-amount-table>
      </v-col>
      <v-col cols="12" md="6">
        <imprest-chart></imprest-chart>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <paid-cheque-chart></paid-cheque-chart>
      </v-col>
      <v-col cols="12" md="6">
        <received-cheque-chart></received-cheque-chart>
      </v-col>
    </v-row>
    <v-row>
    </v-row>
  </div>
</template>
<script>


import ChequeTable from "@/views/reports/ChequeTable";
import ReceivedChequeChart from "@/views/modulePages/treasuryModule/ReceivedChequeChart";
import PaidChequeChart from "@/views/modulePages/treasuryModule/PaidChequeChart";
import ImprestChart from "@/views/modulePages/treasuryModule/ImprestsChart";
import BankCard from "@/views/modulePages/treasuryModule/BankCard";
import CashAndBank from "@/views/modulePages/treasuryModule/CashAndBank";
import HighestBalanceAmountTable from "@/views/modulePages/treasuryModule/HighestBalanceAmount";
export default {
  name: "TreasuryHome",
  components: {
    CashAndBank,
    BankCard,
    ImprestChart,
    HighestBalanceAmountTable,
    PaidChequeChart,
    ReceivedChequeChart,
    ChequeTable,
  },
  props: {
    id: {},
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods : {
    tesst(){
      this.dialog=true
    }
  },
  computed:{
    title(){
      return this.setDocumentTitle('داشبورد خزانه داری')
    }
  }

}
</script>

<style scoped lang="scss"></style>

